import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Box } from '@chakra-ui/react';

import PlanPermission from 'container/PlanPermission';
import { getBaseScenario } from 'redux/PlannerModeSlice';
import apiService from 'services';

import Map from './Map';

const MapTab = () => {
  const { blockId } = useParams();
  const [initialNodes, setInitialNodes] = useState([]);
  const [initialEdges, setInitialEdges] = useState([]);
  const baseScenario = useSelector(getBaseScenario);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiService.getBlockMap(blockId, {
          params: { scenario_id: baseScenario?.scenario_id },
        });

        if (response.data.length > 0) {
          const sourceElements = response.data;
          const nodes = sourceElements.reduce((accumulator: any, sourceElement: any) => {
            // eslint-disable-next-line no-prototype-builtins
            if (sourceElement.hasOwnProperty('data')) {
              sourceElement.type = 'indicator';
              sourceElement.id = String(sourceElement.id);
              sourceElement.position = { x: 0, y: 0 };
              accumulator.push(sourceElement);
            }
            return accumulator;
          }, []);

          const edges = sourceElements.reduce((accumulator: any, sourceElement: any) => {
            // eslint-disable-next-line no-prototype-builtins
            if (sourceElement.hasOwnProperty('source')) {
              sourceElement.type = 'smoothstep';
              sourceElement.animated = false;
              sourceElement.markerEnd = { type: 'arrow' };
              accumulator.push(sourceElement);
            }
            return accumulator;
          }, []);

          setInitialNodes(nodes);
          setInitialEdges(edges);
        }
      } catch {
        // Keep map empty when fetch fails
      }
    };

    fetchData();
  }, [baseScenario, blockId]);

  return initialNodes?.length ? (
    // No border/radius/background of its own — the parent (Table.tsx's
    // caller) already wraps every toolbar tab, this one included, in a
    // bordered `neutral.surface` card. Adding a second bordered frame here
    // nested a box inside that box. flex/minH fills whatever height that
    // outer card has, instead of the old fixed `calc(100vh - 250px)`, which
    // didn't account for it and could over/undershoot the available space.
    <Box flex='1' minH={0} display='flex' flexDirection='column'>
      <Map initialNodes={initialNodes} initialEdges={initialEdges} />
    </Box>
  ) : (
    <></>
  );
};

export default PlanPermission(MapTab);
